export default {
  ALL: 'ALL',
  CAPTURED: 'CAPTURED',
  HUBSPOT: 'HUBSPOT',
  FLOW: 'FLOW',
  BLOG_COMMENT: 'BLOG_COMMENT',
  TICKET_FORM: 'TICKET_FORM',
  FACEBOOK_LEAD_AD: 'FACEBOOK_LEAD_AD',
  VIDEO_FORM: 'VIDEO_FORM'
};